var React = require('react');

function WaveBottom (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M0.00,49.99 C150.00,150.00 271.49,-49.99 500.00,49.99 L500.00,0.00 L0.00,0.00 Z"}));
}

WaveBottom.defaultProps = {"viewBox":"0 0 500 80"};

module.exports = WaveBottom;

WaveBottom.default = WaveBottom;
